module.exports = __webpack_public_path__ + "officialStatic/fonts/Skia.dbe42a1.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Skia.ttf
// module id = CUoa
// module chunks = 0